/*
 * @Description: 端口识别号列表
 * @Author: 杨志航
 * @Date: 2026-06-30 15:04:30
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  message,
  Icon,
  Table,
  Modal,
} from 'antd'
import { allTrim, filterParams } from '@/utils'
import Auth from '@/components/AuthMiddleware'

const { Column } = Table
const FormItem = Form.Item

let pageSize = 10
let currentPage = 1

const PortTable = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue } = props.form
  const { supplierId, authList } = props
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [count, setCount] = useState(0)
  const [editingKey, setEditingKey] = useState('')

  useEffect(() => {
    currentPage = 1
    pageSize = 10
    getList(supplierId)
  }, [])

  const getList = id => {
    setLoading(true)
    api.getPortIdentifyList({
      supplierId: id,
      limit: pageSize,
      page: currentPage
    }).then(data => {
      setList(data.list)
      setCount(data.count)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const onChangeTable = (pagination, filters, sorter) => {
    currentPage = pagination.current
    pageSize = pagination.pageSize
    getList(supplierId)
  }

  const handleDelete = id => { 
    Modal.confirm({
      title: '请确认是否要删除该端口识别号？',
      content: '删除后在订单生效时将无法选择该端口识别号，但在历史订单中的端口识别号不会被删除。',
      icon: <Icon type="close-circle" />,
      onOk: () => {
        api.deletePortIdentify({ id }).then(() => {
          message.success('删除成功')
          currentPage = 1
          getList(supplierId)
        })
      }
    })
  }

  const hadleSave = id => {
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields(err => {
      if (!err) {
        let vals = filterParams(getFieldsValue())
        vals = {
          id,
          ...vals,
        }
        setLoading(true)
        api.updatePortIdentify(vals).then(() => {
          setLoading(false)
          setEditingKey('')
          message.success('保存成功')
          currentPage = 1
          pageSize = 10
          getList(supplierId)
        }).catch(() => setLoading(false))
      }
    })
  }

  return (
    <Form>
      <Table
        size="small"
        dataSource={list}
        rowKey="id"
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
      >
        <Column title="端口识别号" 
          dataIndex="portIdentify" 
          render={(text, record) => (
            <>
              {editingKey === record.id ? (
                <FormItem style={{ marginBottom: 0 }}>
                  {getFieldDecorator('portIdentify', {
                    initialValue: text,
                    rules: [{ required: true, message: '请输入端口识别号' }]
                  })(<Input size="small" />)}
                </FormItem>
              ) : (
                <div>{text}</div>
              )}
            </>
          )}
        />
        <Column 
          title="端口名称" 
          dataIndex="portName" 
          render={(text, record) => (
            <>
              {editingKey === record.id ? (
                <FormItem style={{ marginBottom: 0 }}>
                  {getFieldDecorator('portName', {
                    initialValue: text,
                    rules: [{ required: true, message: '请输入端口名称' }]
                  })(<Input size="small" />)}
                </FormItem>
              ) : (
                <div>{text}</div>
              )}
            </>
          )}
        />
        <Column title="导入人" dataIndex="addName" width={100} />
        <Column title="导入时间" dataIndex="addTime" width={180} />
        <Column title="操作" key="set" width={100} align='center' render={(text, record) => (
          <>
            {editingKey === '' && (
              <>
                <Auth auths={authList} code="operate">
                  <a onClick={() => setEditingKey(record.id)}>编辑</a>
                </Auth>
                <Auth auths={authList} code="operate">
                  <a style={{ color: 'red', marginLeft: 5 }} onClick={() => handleDelete(record.id)}>删除</a>
                </Auth>
              </>
            )}
            {editingKey === record.id && (
              <>
                <Auth auths={authList} code="operate">
                  <a onClick={() => hadleSave(record.id)}>保存</a>
                </Auth>
                <Auth auths={authList} code="operate">
                  <a style={{ marginLeft: 5 }} onClick={() => setEditingKey('')}>取消</a>
                </Auth>
              </>
            )}
          </>
        )} />
      </Table>
    </Form>
  )
}

export default Form.create()(PortTable)